export default "__VITE_ASSET__b4f9da75__"